// Encodes SVG element into Base64 image so it can be used as a texture in PIXI
const svgToDataUrl = svg => {
  const serialiser = new XMLSerializer();
  const svgString = serialiser.serializeToString(svg);
  return encodeSvgFromString(svgString);
};

export const encodeSvgFromString = svgString => {
  return `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(svgString)))}`;
};

export default svgToDataUrl;
